import { Text, textColors } from '@taxdown/piccolo-web';
import styled from 'styled-components';

export const StrikethroughText = styled(Text)`
  text-decoration: line-through;
  color: ${textColors.grey};
`;
